import BaseEvent from './base_event';

export default class WinEvent extends BaseEvent {
    static canOccur(gameState) { return gameState.distanceLeft <= 0; }

    enter(gameState) {
        if (typeof ga === "function") ga('send', 'event', 'game', 'WinEvent');

        this.ui.showDialog({
            message: "That wasn't easy, but you managed to reach your destination!\nCongratulations, captain! ",
            options: [{text: "Hoooray!"}]
        }, () => {
            game.gameState.win();
            game.state.start("win");
        })
    }
}


// WEBPACK FOOTER //
// ./src/states/events/win_event.js